import React, { Component } from 'react';
import { Report } from 'powerbi-report-component';
import Header from '../AssetHealthApp/Header';
import { powerbireportId } from '../../utils/helper';
import { session } from '../../Service/APIService';

// const embedId = "c104699e-d3ab-43f2-a29c-d28134f96ac5";
const embedId = powerbireportId(); // power BI report Id

export default class PowerBI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: '',
      embedUrl: '',
    };
  }

  async componentDidMount() {
    console.log('powerbi did mount');
    const baseUrl = window.location.origin;
    const URL = `${baseUrl}/powerbi/getembedinfo`;

    let response = await fetch(URL);
    if (response.ok) {
      // if HTTP-status is 200-299
      // debugger;
      // get the response body (the method explained below)
      let json = await response.json();
      console.log('fetch respone json', json);
      this.setState({
        accessToken: json.accessToken,
        embedUrl: json.embedUrl,
      });
    } else {
      alert('HTTP-Error: ' + response.status);
    }
  }

  handleReportLoad = (report) => {
    const sessionId = session.client();
    const clientId = parseInt(sessionId);
    if (clientId > 0) {
      console.log('applying client filter');
      this.report = report;
      const filter = [
        {
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: 'powerbidb pdsdata',
            column: 'ClientId',
          },
          displaySettings: {
            isLockedInViewMode: true,
            isHiddenInViewMode: true,
          },
          operator: 'In',
          values: [clientId],
        },
        {
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: 'powerbidb pdsdata',
            column: 'Asset',
          },
          displaySettings: {
            isLockedInViewMode: false,
            isHiddenInViewMode: false,
          },
          operator: 'All',
          values: ['XYZ'],
        },
      ];
      this.report
        .setFilters(filter)
        .then(function () {
          console.log('Report filter was set.');
        })
        .catch(function (errors) {
          console.log('Error during filtering', errors);
        });
    }
  };

  render() {
    const extraSettings = {
      filterPaneEnabled: true, //true
      // navContentPaneEnabled: false, //true

      navContentPaneEnabled: true, //
      hideErrors: false, // Use this *only* when you want to override error experience i.e, use onError
      // ... more custom settings
    };

    // debugger;
    return (
      <div>
        <Header
          BrandText={'PowerBI Report'}
          legendObj={[]}
          islegendObj={false}
          iconsObj={[]}
        ></Header>
        {this.state.accessToken !== '' && (
          <Report
            tokenType="Embed" // "Aad"
            style={{ height: '600px', width: '100%' }}
            accessToken={this.state.accessToken} // accessToken goes here
            embedUrl={this.state.embedUrl}
            embedId={embedId} // report or dashboard Id goes here
            // pageName="Akshat" // set as current page of the report
            reportMode="View" // open report in a particular mode view/edit/create
            extraSettings={extraSettings}
            permissions="All"
            onLoad={this.handleReportLoad}
          />
        )}
      </div>
    );
  }
}
